var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"hide-footer":true,"no-close-on-backdrop":true,"title":_vm.$t(''),"centered":"","id":"modal-show-evento"},on:{"hidden":_vm.cancelar}},[_vm._v("\n    TESTE "+_vm._s(_vm.evento)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }